import { connect } from 'react-redux'
import {
  setAvailableInstallers,
  setAvailableVendors,
  setVendors,
  createNewServiceCompany,
  resetCreateServiceCompanyStatusMessages,
  types,
} from '../../../../actions/projects/form_actions'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.CREATE_NEW_INSTALLER])

export default connect(
  (state: any) => ({
    availableInstallers: state.projects?.form?.availableInstallers || [],
    availableVendors: state.projects?.form?.availableVendors || [],
    vendors: state.projects?.form?.vendors || [],
    isFetching: loadingSelector(state),
    createServiceCompanyError: state.projects?.form?.createServiceCompany?.error,
    createServiceCompanySuccess: state.projects?.form?.createServiceCompany?.success,
  }),
  {
    setAvailableInstallers,
    setAvailableVendors,
    setVendors,
    createNewServiceCompany,
    resetCreateServiceCompanyStatusMessages,
  }
)
